import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

import { NotificationManager, PaymentV2Api } from '@atlas/core';
import { parseWithdrawalQuery } from '@atlas/routing';
import { Button, DefaultPopup, Input } from '@atlas/ui';

import PaymentListItem from 'src/components/ClientProfile/Payment/PaymentListItem';

const AtlasTransferPopup = ({ data, id }) => {
  const { paymentMethod, pmId, publicPaymentId, redirectUrl = '' } = data;
  const [isActiveInput, setIsActiveInput] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [bankDetailsInput, setBankDetailsInput] = useState('');

  const { amount, currency } = parseWithdrawalQuery(redirectUrl);

  const handleClose = useCallback(() => {
    NotificationManager.removeNotification(id);
  }, [id]);

  const handleBlur = useCallback(() => {
    setIsActiveInput(false);
  }, []);

  const handleFocus = useCallback(() => {
    setIsActiveInput(true);
  }, []);

  const changeBankDetails = useCallback(e => {
    const value = e.target.value.trim();

    setBankDetailsInput(value);
  }, []);

  const handleWithdrawalButton = useCallback(async () => {
    const requestData = {
      additionalParameters: {
        bankingDetail: bankDetailsInput,
        publicPaymentId,
      },
      amount: amount,
      currency: currency,
      pmId: pmId,
    };

    setIsSubmitting(true);

    try {
      const response = await PaymentV2Api.createAsyncWithdrawalV2(requestData);

      NotificationManager.display({
        data: {
          amount,
          currency,
          publicPaymentId: response?.publicPaymentId,
          paymentMethod,
        },
        message: 'successfulWithdrawal',
        type: 'successfulWithdrawal',
      });
    } catch (error) {
      NotificationManager.notify({
        message: 'withdrawal_failed_message',
        status: 'error',
        type: 'notification',
      });
    } finally {
      setIsSubmitting(false);
      handleClose();
    }
  }, [amount, bankDetailsInput, currency, handleClose, paymentMethod, pmId, publicPaymentId]);

  return (
    <DefaultPopup
      className="withdrawal-atlas-transfer-popup"
      headerTitle="withdrawal"
      headerTitlePosition="left"
      onClose={handleClose}
    >
      <div className="popup-payment-method">
        <PaymentListItem amount={amount} isShowMinMaxAmount payment={paymentMethod} />
      </div>
      <div className="popup__content">
        <div className="payment-popup-block">
          <Input
            active={isActiveInput}
            className="popup-input"
            label="bank_details"
            onBlur={handleBlur}
            onChange={changeBankDetails}
            onFocus={handleFocus}
            value={bankDetailsInput}
          />
        </div>
      </div>
      <div className="popup__footer">
        <Button
          className="primary big block"
          disabled={!bankDetailsInput || isSubmitting}
          label="withdrawal"
          loading={isSubmitting}
          onClick={handleWithdrawalButton}
        />
      </div>
    </DefaultPopup>
  );
};

AtlasTransferPopup.propTypes = {
  data: PropTypes.shape({
    paymentMethod: PropTypes.object,
    pmId: PropTypes.string,
    publicPaymentId: PropTypes.string,
    redirectUrl: PropTypes.string.isRequired,
  }).isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default AtlasTransferPopup;
